<template>
    <div class="switcher">
        <b-dropdown v-if="isLoggedIn">
            <template #button-content v-if="currentTeam && (!objectStoreOnly || isCustomerOwner())">
                <div class="team-avatar-container--menu">
                    <vue-gravatar :email="currentUser.email_address" class="img-avatar" :size="50"/>
                    <f-team-avatar :colour="currentTeam.color" />
                    <div v-if="currentTeam.projects">
                        <span class="selected__regions" :class="{'first' : index === 0}"
                        v-if="currentTeam.projects.find(item => item.id === currentProject.id).provs && !selectedRegion
                        || selectedRegion.indexOf(p.region_name) > -1
                        || ((p.region_name === 'staging101' || p.region_name === 'ams2') && selectedRegion.indexOf('core') > -1)"
                        v-for="(p, index) in currentTeam.projects.find(item => item.id === currentProject.id).provs" :key="p + index" @click.prevent="toggleSelectedRegion(p.region_name, project)">
                            <fRegionFlag :region="p.region_name" />
                        </span>
                    </div>
                </div>
            </template>
            <template #button-content v-else>
                <div class="user-avatar-container--menu">
                    <vue-gravatar :email="currentUser.email_address" class="img-avatar" :size="50"/>
                </div>
            </template>
            <div class="teams__list" v-if="!objectStoreOnly || isCustomerOwner()" @scroll="handleScroll" :class="{'reachedbottom': hasScrolledToBottom, 'noscrollstyle' : teams.length < 4}">
                <b-dropdown-item href="#" v-for="(team, index) in teams" :key="team.id + index" class="team__item active__item" v-if="team.id === currentTeam.id"><f-team-avatar :colour="team.color" />
                    <strong class="team__header" @click="gotoAccount()">{{ team.name }}<br><small>{{ team.description }}</small>
                    <i ref="iconEye" class="fa fa-eye show__team"></i></strong>
                    <div class="dropdown-item project__item" href="#" v-for="(project, index) in team.projects" :key="index" :class="{'active__item': project.id === currentProject.id}">
                        <span class="project__select" :class="{'project__select--fullwidth': project.id !== currentProject.id}" @click.prevent="changeCurrentProject(project)">{{ project.name }}</span>
                        <div class="region__select" v-if="project.id === currentProject.id">
                            <a href="#" v-for="(p, index) in project.provs" :key="p + index" @click.prevent="toggleSelectedRegion(p.region_name, project)" :class="{'active' : !selectedRegion || selectedRegion.indexOf(p.region_name) > -1 || ((p.region_name === 'staging101' || p.region_name === 'ams2') && selectedRegion.indexOf('core') > -1)}">
                                <fRegionFlag :region="p.region_name" />
                            </a>
                        </div>
                    </div>
                    <span class="project__item" v-if="!team.projects || team.projects.length === 0">No projects</span>
                </b-dropdown-item>

                <b-dropdown-item href="#" v-for="(team, index) in teams" :key="team.id + index"  v-if="team.id !== currentTeam.id" class="team__item"><f-team-avatar :colour="team.color" /><strong>{{ team.name }}</strong>
                    <b-dropdown-item class="project__item" href="#" v-for="(project, index) in team.projects" :key="index" :class="{'active__item': project.id === currentProject.id}" @click.prevent="changeCurrentProject(project)">{{ project.name }}</b-dropdown-item>
                    <span class="project__item incomplete" v-if="!team.projects || team.projects.length === 0" @click.prevent="findRegistrationStep('/account/team', team.id)">Complete team..</span>
                </b-dropdown-item>
            </div>
            <router-link :to="{name: 'profile'}" class="nav-link">Profile</router-link>
            <router-link :to="{name: 'team'}" v-if="!objectStoreOnly || isCustomerOwner()" class="nav-link">Teams</router-link>
            <router-link :to="{name: 'billing'}" v-if="!objectStoreOnly" class="nav-link">Billing details</router-link>
            <router-link :to="{name: 'logout'}" class="nav-link logout">Log out</router-link>
      </b-dropdown>
      <f-quota v-if="hasToken && !isHome" :inSidebar="true" :key="instanceKey + volumeKey" class="d-none" />
  </div>
</template>

<script>
const vueGravatar = () => import('vue-gravatar');
const fTeamAvatar = () => import('@/components/svg/create-team-avatar');
const fRegionFlag = () => import('@/components/f-region-flag');
import fQuota from '@/components/f-quota';
import { isLoggedIn } from '../../assets/js/auth';
import findRegistrationStep from '@/mixins/find-registration-step';

export default {
    data() {
        return {
            hasScrolledToBottom: false,
        }
    },

    computed: {
        currentUser() {
          return this.$store.state.user.info;
        },

        currentTeam() {
          return this.$store.state.team.current;
        },

        teams() {
          return this.$store.state.team.info;
        },

        instanceKey() {
            return this.$store.state.instance.updateKey;
        },

        volumeKey() {
            return this.$store.state.volumev3.updateKey;
        },


        maxTeams() {
            let data =  0;
            this.$store.state.customer.list.forEach((item) => {
                data += item.max_teams;
            })
            return data;
        },

        currentProject() {
            return JSON.parse(localStorage.getItem('current_project'));
        },

        selectedRegion() {
            return localStorage.getItem('selected_region') ? JSON.parse(localStorage.getItem('selected_region')) : false;
        },
    },

    methods: {
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
              if (this.$route.meta.sidebar) {
                  return this.$route.meta.sidebar.indexOf(path) > -1;
              }
            });
        },

        toggleSelectedRegion(regionName, project) {
            let data = localStorage.getItem('selected_region') ? JSON.parse(localStorage.getItem('selected_region')) : [];
            if (regionName === 'staging101' || regionName === 'ams2') {
                regionName = 'core';
            }
            if (data.length === 0) {
                project.provs.forEach((prov) => {
                    if (prov.region_name === 'staging101' || prov.region_name === 'ams2') {
                        prov.region_name = 'core';
                    }
                    if (prov.region_name !== regionName) {
                        data.push(prov.region_name);
                    }
                })
                localStorage.setItem('selected_region', JSON.stringify(data));
            } else {
                let index = data.indexOf(regionName);
                if (index >= 0) {
                    data.splice(index, 1);
                } else {
                    data.push(regionName);
                }
                if (data.length === 0 || data.length === 2) {
                    localStorage.removeItem('selected_region');
                } else {
                    localStorage.setItem('selected_region', JSON.stringify(data));
                }
            }
            localStorage.removeItem('region_tokens');
            this.changeCurrentProject(project);
        },

        gotoAccount() {
            if (this.$route.name !== 'team') {
                this.$router.push({ name: 'team' });
            }
        },

        handleScroll: function(el) {
            if((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
                this.hasScrolledToBottom = true;
            } else {
                this.hasScrolledToBottom = false;
            }
        },
    },

    components: {
        vueGravatar,
        fTeamAvatar,
        fRegionFlag,
        fQuota,
    },
}
</script>
<style>
.switcher {
    margin-top: 10px;
}
.switcher .show > .btn-secondary.dropdown-toggle {
    border: 1px solid #ced8dc;
    background: #fff;
}
.switcher .btn {
    background: #fff;
    padding: 5px 15px 5px 3px;
    border-radius: 30px;
    color: #597985;
}
.switcher .b-dropdown {
    position: relative;
    right: 0;
}
.switcher .team-avatar-container--menu {
    position: relative;
}
.switcher .team-avatar-container--menu .img-avatar {
    position: absolute;
    right: 2px;
    bottom: -3px;
    height: 25px;
    width: 25px;
    padding: 0;
    border: 2px solid #f3f3f3;
    left: auto;
    background: #fff;
}
.switcher .user-avatar-container--menu {
    width: 50px;
    float: left;
}
.switcher .user-avatar-container--menu  .img-avatar {
    height: 40px;
    width: 40px;
}
.switcher .btn strong {
    margin-top: 5px;
}
.switcher .btn .profile__dropdown__team {
    height: 17px;
}
.switcher .b-dropdown {
    z-index: 10;
}

.switcher .dropdown-toggle::after {
    vertical-align: -9px;
}
.switcher .teams__list {
    max-height: 400px;
    overflow-y: scroll;
    overflow-x: hidden;
    box-shadow: inset 0 -10px 10px -10px #c2cfd6;
    border-bottom: 1px solid #c2cfd6;
}
.switcher .teams__list.reachedbottom,
.switcher .teams__list.noscrollstyle {
    box-shadow: none;
}
.switcher .teams__list .team-avatar {
    height: 24px;
    width: 24px;
    float: left;
    margin: 10px;
    border: 2px solid #FFF;
    border-radius: 50%;
}
.switcher .teams__list .dropdown-item {
    padding: 0 10px 10px 0px;
    width: calc(100% - 10px);
}
.switcher .dropdown-item strong {
    padding: 10px;
    display: block;
    cursor: default;
    width: calc(100% + 10px);
}
.switcher .dropdown-item.active__item strong {
    background: #25b3b8;
    width: calc(100% + 10px);
    margin-bottom: 10px;
    border-top-right-radius: 4px;
    color: #fff;
}
.switcher .dropdown-item {
    color: #597985;
}
.switcher .dropdown-item .dropdown-item {
    padding: 10px;
}
.switcher .dropdown-item .dropdown-item:hover {
    background: rgba(37, 179, 184, 0.30);
}
.switcher .dropdown-item.active__item {
    background: rgba(37, 179, 184, 0.30);
    border-left: 2px solid #25b3b8;
    cursor: default;
}
.bla .switcher .teams__list {
    max-height: 200px;
    overflow: hidden;
    box-shadow: 0 4px 2px -2px gray;
}
.switcher .dropdown-menu > dropdown-item {
    padding: 10px;
}
.switcher .dropdown-menu {
    padding: 10px;
    min-width: 300px;
}
.team__item {
    margin-bottom: 10px;
    background: rgba(37, 179, 184, 0.20);
    max-width: 450px;
    overflow: hidden;
}
.team__item:hover,
.team__item:active,
.team__item:focus {
    background: rgba(37, 179, 184, 0.25);
}
.project__item {
    margin-left: 10px;
    width: calc(100% - 10px);
    cursor: pointer;
}

.team-avatar-container--menu {
    width: 50px;
    height: 40px;
}
.team-avatar-container--menu > img {
    width: 40px;
    height: 40px;
}
.sidebar-bottom .team-avatar {
    position: absolute;
    width: 25px;
    height: 25px;
    right: -3px;
    bottom: 0px;
}
.active__item .dropdown-item:last-child,
.active__item .dropdown-item,
.dropdown-item:last-child {
    border-bottom: 0;
}
.project__select {
    cursor: pointer;
    display: inline-block;
    width: 165px;
    overflow: hidden;
    margin: -10px;
    padding: 10px;
}
.project__select--fullwidth {
    width: calc(100% + 20px);
}
.region__select {
    float: right;
    padding-left: 8px;
    border-left: 1px solid #25b3b8;
}
.region__select > a {
    float: left;
    padding: 0 2px;
    opacity: .5;
}
.region__select > a.active {
    opacity: 1;
}
.teams__list .region__select .az-flag,
.teams__list .region__select .az-flag svg {
    position: relative;
}
.teams__list .az-flag {
    left: inherit !important;
    right: inherit !important;
    bottom: inherit !important;
    position: relative !important;
    margin: 0 !important;
}
.nav-link:hover {
    background: rgba(37, 179, 184, 0.20)
}
.nav-link.logout:hover {
    color: rgba(184, 37, 37, 1);
    background: rgba(184, 37, 37, 0.2);
}
.selected__regions {
    position: absolute;
    left: 5px;
    bottom: 0;
}
.selected__regions.first {
    position: absolute;
    left: 13px;
}
.selected__regions .az-flag,
.selected__regions svg {
    height: 10px !important;
    width: 10px !important;
    left: 0;
    bottom: 0;
}
.dropdown-item.active__item .team__header .show__team {
    display: none;
    color: #fff;
    position: absolute;
    top: 12px;
    right: 0;
    cursor: pointer;
}
.dropdown-item.active__item .team__header:hover .show__team {
    display: block;
}
.project__item.incomplete {
  width: calc(100% - 10px);
  display: block;
  padding: 4px;
  background:orange;
  color: #523500;
}
.project__item.incomplete:hover {
    background:rgb(255, 188, 64);
}
</style>
